export enum AgGridRowSelection {
  SINGLE = 'singleRow',
  MULTIPLE = 'multiRow'
}
